import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingStaffResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      hours: '',
      result: '',
      confirmed: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.changeResult = this.changeResult.bind(this);
    this.setNoAttendance = this.setNoAttendance.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    var valido = /^[\d,.]+$/.test(event.target.value);
    if (event.target.value === "" || valido === true) {
      var self = this;
      change[name] = event.target.value
      this.setState(change);
    }
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_certification_staff_id !== 'undefined')){
      this.setState({
        hours: newProps.hours,
        result: newProps.result,
        confirmed: newProps.confirmed,
        id: newProps.training_certification_staff_id,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando resultado do aluno
  changeResult(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      result: this.state.result,
      hours: this.state.hours,
      confirmed: this.state.confirmed,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/tripulante/resultado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Marcar o aluno como faltante
  setNoAttendance(event) {
    if (window.confirm(this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.MarcarAlunoComoFaltante)) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/tripulante/faltante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <form onSubmit={this.changeResult}>
          <table className="table">
            <thead>
              <tr>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Nota}</th>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Horas}</th>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.MarcarComoFaltante}</th>
                <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Acoes}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                  <td>
                    <input value={this.state.result}  name="result" className="form-control text-center" required onChange={this.handleChange.bind(this, 'result')}/>
                  </td>
                  <td>
                    <input value={this.state.hours} name="hours" className="form-control text-center" onChange={this.handleChange.bind(this, 'hours')}/>
                  </td>
                  <td>
                    <button type="button" className="btn btn-warning" onClick={() => this.setNoAttendance()}><i className="fa fa-fw fa-warning"></i> {this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.Faltante}</button>
                  </td>
                  <td>
                    <button type="submit" className="btn btn-info btn-block"><i className="fa fa-fw fa-refresh"></i> {this.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaTripulantes.botaoAtualizarNota}</button>
                  </td>
              </tr>
            </tbody>
          </table>
        </form>  
      </div>
    );
  }
}

export default TrainingStaffResult;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffResult.js